import React from 'react';
import { Link } from 'react-router-dom';

const CareerGoals = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <Link to="/services/career" className="text-indigo-600 hover:text-indigo-700 mb-4 inline-block">
          Back to Career Dashboard
        </Link>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Career Goals</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600 mb-4">
            Set and track your career milestones.
          </p>
          <p className="text-sm text-gray-500">Coming soon: Goal management interface</p>
        </div>
      </div>
    </div>
  );
};

export default CareerGoals;
